export const STRIPE_PAYMENT_TYPE = 'stripe'
export const STRIPE_PAYMENT_ELEMENT_TYPE = 'stripe_payment_element'
export const CREDIT_PAYMENT_TYPE = 'credit'
export const PROMO_PAYMENT_TYPE = 'promo'
export const VOUCHER_PAYMENT_TYPE = 'voucher'
export const GIFT_CARD_PAYMENT_TYPE = 'gift_card'
export const VELOCITY_PAYMENT_TYPE = 'velocity'
export const BRAINTREE_PAYMENT_TYPE = 'braintree'
export const RAZORPAY_PAYMENT_TYPE = 'razorpay'
export const KLARNA_PAYMENT_TYPE = 'klarna'
export const BRIDGER_PAY_PAYMENT_TYPE = 'bridgerpay'
export const AFTER_PAY_BP_PAYMENT_TYPE = 'afterpay_bp'
export const HOOLAH_BP_PAYMENT_TYPE = 'hoolah_bp'
export const ATOME_BP_PAYMENT_TYPE = 'atome_bp'
export const WAAVE_BP_PAYMENT_TYPE = 'waave_bp'
export const GO_CARDLESS_PAYMENT_TYPE = 'gocardless'
export const EXPRESS_PAYMENT_TYPE = 'express'
export const APPLE_PAY_PAYMENT_TYPE = 'applepay'
export const GOOGLE_PAY_PAYMENT_TYPE = 'googlepay'
export const KLARNA_BP_PAYMENT_TYPE = 'klarna_bp'
export const LOYALTY_DISCOUNTED_INSURANCE = 'le_points_discounted_insurance'
export const LOYALTY_POINTS_PAYMENT_TYPE = 'le_points'
export const STRIPE_PAYMENT_ELEMENT_CARD_TYPE = 'stripe_payment_element_card'
export const STRIPE_PAYMENT_ELEMENT_GIROPAY_TYPE = 'stripe_payment_element_giropay'
export const STRIPE_PAYMENT_ELEMENT_IDEAL_TYPE = 'stripe_payment_element_ideal'
export const STRIPE_PAYMENT_ELEMENT_KLARNA_TYPE = 'stripe_payment_element_klarna'
export const STRIPE_PAYMENT_ELEMENT_PAYNOW_TYPE = 'stripe_payment_element_paynow'
export const STRIPE_PAYMENT_ELEMENT_GRABPAY_TYPE = 'stripe_payment_element_grabpay'
export const STRIPE_PAYMENT_ELEMENT_WECHATPAY_TYPE = 'stripe_payment_element_wechatpay'

export const STRIPE_CUSTOM_PAYTO_TYPE = 'stripe_custom_payto'
export const STRIPE_PAYMENT_ELEMENT_WALLET_TYPE = 'stripe_payment_element_wallet'
export const STRIPE_PAYMENT_ELEMENT_GOOGLE_PAY_TYPE = 'stripe_payment_element_google_pay'
export const STRIPE_PAYMENT_ELEMENT_APPLE_PAY_TYPE = 'stripe_payment_element_apple_pay'
export const STRIPE_PAYMENT_ELEMENT_AFTERPAY_TYPE = 'stripe_payment_element_afterpay'
export const CAR_HIRE_PAY_ON_ARRIVAL_TYPE = 'car_hire_pay_on_arrival'
export const SECURE_PAYMENT_TYPE = 'secure_payment'
export const FLYING_BLUE_PAYMENT_TYPE = 'flying_blue'
export const AZUPAY_PAY_ID_PAYMENT_TYPE = 'azupay_pay_id'
export const PAYPAL_PAYMENT_TYPE = 'paypal'
export const PAYLATER_PAYMENT_TYPE = 'paylater'
export const STRIPE_TERMINAL_PAYMENT_TYPE = 'stripe_terminal'

const STRIPE_PAYMENT_ELEMENT_TYPES = [
  STRIPE_PAYMENT_ELEMENT_CARD_TYPE,
  STRIPE_PAYMENT_ELEMENT_GOOGLE_PAY_TYPE,
  STRIPE_PAYMENT_ELEMENT_APPLE_PAY_TYPE,
  STRIPE_PAYMENT_ELEMENT_AFTERPAY_TYPE,
  STRIPE_PAYMENT_ELEMENT_GIROPAY_TYPE,
  STRIPE_PAYMENT_ELEMENT_IDEAL_TYPE,
  STRIPE_PAYMENT_ELEMENT_KLARNA_TYPE,
  STRIPE_PAYMENT_ELEMENT_PAYNOW_TYPE,
  STRIPE_PAYMENT_ELEMENT_WECHATPAY_TYPE,
  STRIPE_PAYMENT_ELEMENT_GRABPAY_TYPE,
] as const

// All payment methods which are subtypes of the Stripe Payment Element
export const STRIPE_PAYMENT_ELEMENT_METHODS: Array<string> = [...STRIPE_PAYMENT_ELEMENT_TYPES]

export const paymentMethodLabels: Record<string, string> = {
  [APPLE_PAY_PAYMENT_TYPE]: 'Apple Pay',
  [GOOGLE_PAY_PAYMENT_TYPE]: 'Google Pay',
  [STRIPE_PAYMENT_ELEMENT_TYPE]: 'Stripe Payment Element',
  [STRIPE_PAYMENT_ELEMENT_CARD_TYPE]: 'Credit or debit card',
  [BRAINTREE_PAYMENT_TYPE]: 'PayPal',
  [VELOCITY_PAYMENT_TYPE]: 'Velocity Points',
  [KLARNA_PAYMENT_TYPE]: 'Klarna',
  [KLARNA_BP_PAYMENT_TYPE]: 'Klarna',
  [AFTER_PAY_BP_PAYMENT_TYPE]: 'Afterpay',
  [HOOLAH_BP_PAYMENT_TYPE]: 'Hoolah',
  [ATOME_BP_PAYMENT_TYPE]: 'Atome',
  [WAAVE_BP_PAYMENT_TYPE]: 'Waave',
  [RAZORPAY_PAYMENT_TYPE]: 'Razorpay',
  [GO_CARDLESS_PAYMENT_TYPE]: 'PayTo',
  [FLYING_BLUE_PAYMENT_TYPE]: 'Flyingblue',
  [AZUPAY_PAY_ID_PAYMENT_TYPE]: 'PayID',
  [STRIPE_TERMINAL_PAYMENT_TYPE]: 'Stripe Terminal',
}

export type PaymentMethod =
  typeof BRAINTREE_PAYMENT_TYPE |
  typeof EXPRESS_PAYMENT_TYPE |
  typeof STRIPE_PAYMENT_ELEMENT_APPLE_PAY_TYPE |
  typeof STRIPE_PAYMENT_ELEMENT_GOOGLE_PAY_TYPE |
  typeof STRIPE_PAYMENT_ELEMENT_CARD_TYPE |
  typeof STRIPE_PAYMENT_ELEMENT_GIROPAY_TYPE |
  typeof STRIPE_PAYMENT_ELEMENT_IDEAL_TYPE |
  typeof STRIPE_PAYMENT_ELEMENT_KLARNA_TYPE |
  typeof STRIPE_PAYMENT_ELEMENT_PAYNOW_TYPE |
  typeof STRIPE_PAYMENT_ELEMENT_AFTERPAY_TYPE |
  typeof STRIPE_PAYMENT_ELEMENT_WECHATPAY_TYPE |
  typeof STRIPE_PAYMENT_ELEMENT_GRABPAY_TYPE |
  typeof STRIPE_CUSTOM_PAYTO_TYPE |
  typeof FLYING_BLUE_PAYMENT_TYPE |
  typeof AZUPAY_PAY_ID_PAYMENT_TYPE |
  typeof RAZORPAY_PAYMENT_TYPE |
  typeof KLARNA_PAYMENT_TYPE |
  typeof AFTER_PAY_BP_PAYMENT_TYPE |
  typeof HOOLAH_BP_PAYMENT_TYPE |
  typeof ATOME_BP_PAYMENT_TYPE |
  typeof VELOCITY_PAYMENT_TYPE |
  typeof APPLE_PAY_PAYMENT_TYPE |
  typeof GOOGLE_PAY_PAYMENT_TYPE |
  typeof KLARNA_BP_PAYMENT_TYPE |
  typeof WAAVE_BP_PAYMENT_TYPE |
  typeof GO_CARDLESS_PAYMENT_TYPE |
  typeof SECURE_PAYMENT_TYPE |
  typeof PAYPAL_PAYMENT_TYPE |
  typeof PAYLATER_PAYMENT_TYPE |
  typeof STRIPE_PAYMENT_TYPE |
  typeof CREDIT_PAYMENT_TYPE |
  typeof STRIPE_TERMINAL_PAYMENT_TYPE

export type BriderPayPaymentMethod =
  typeof AFTER_PAY_BP_PAYMENT_TYPE |
  typeof HOOLAH_BP_PAYMENT_TYPE |
  typeof ATOME_BP_PAYMENT_TYPE |
  typeof KLARNA_BP_PAYMENT_TYPE |
  typeof WAAVE_BP_PAYMENT_TYPE

export type StripePaymentElementMethod =
  typeof STRIPE_PAYMENT_ELEMENT_CARD_TYPE |
  typeof STRIPE_PAYMENT_ELEMENT_WALLET_TYPE |
  typeof STRIPE_PAYMENT_ELEMENT_AFTERPAY_TYPE

// The payment methods used for the final payment,
// after credits, promo have been applied
export const PAYMENT_TYPES_NOPROMO: Array<PaymentMethod> = [
  BRAINTREE_PAYMENT_TYPE,
  RAZORPAY_PAYMENT_TYPE,
  KLARNA_PAYMENT_TYPE,
  AFTER_PAY_BP_PAYMENT_TYPE,
  HOOLAH_BP_PAYMENT_TYPE,
  ATOME_BP_PAYMENT_TYPE,
  APPLE_PAY_PAYMENT_TYPE,
  GOOGLE_PAY_PAYMENT_TYPE,
  KLARNA_BP_PAYMENT_TYPE,
  WAAVE_BP_PAYMENT_TYPE,
  GO_CARDLESS_PAYMENT_TYPE,
  FLYING_BLUE_PAYMENT_TYPE,
  AZUPAY_PAY_ID_PAYMENT_TYPE,
  ...STRIPE_PAYMENT_ELEMENT_TYPES,
]

export const PAYMENT_TYPES_SIMPLE: Array<PaymentMethod> = [
  RAZORPAY_PAYMENT_TYPE,
  KLARNA_PAYMENT_TYPE,
  GO_CARDLESS_PAYMENT_TYPE,
  FLYING_BLUE_PAYMENT_TYPE,
  AZUPAY_PAY_ID_PAYMENT_TYPE,
]
export const PAYMENT_TYPES_BRIDGER: Array<PaymentMethod> = [
  KLARNA_BP_PAYMENT_TYPE,
  AFTER_PAY_BP_PAYMENT_TYPE,
  HOOLAH_BP_PAYMENT_TYPE,
  ATOME_BP_PAYMENT_TYPE,
  WAAVE_BP_PAYMENT_TYPE,
]

export const PAYMENT_TYPES_STRIPE: Array<PaymentMethod> = [
  APPLE_PAY_PAYMENT_TYPE,
  GOOGLE_PAY_PAYMENT_TYPE,
  SECURE_PAYMENT_TYPE,
  EXPRESS_PAYMENT_TYPE,
  STRIPE_CUSTOM_PAYTO_TYPE,
  STRIPE_TERMINAL_PAYMENT_TYPE,
  ...STRIPE_PAYMENT_ELEMENT_TYPES,
]

export type StripePaymentElementPaymentMethodType = 'card' | 'payto' | 'ideal' | 'klarna' | 'giropay' | 'afterpay_clearpay' | 'paynow' | 'wechat_pay' | 'grabpay'
export const STRIPE_PAYMENT_ELEMENT_METHODS_MAP: Utils.PartialRecord<PaymentMethod, StripePaymentElementPaymentMethodType> = {
  [STRIPE_PAYMENT_ELEMENT_CARD_TYPE]: 'card',
  [STRIPE_PAYMENT_ELEMENT_GIROPAY_TYPE]: 'giropay',
  [STRIPE_PAYMENT_ELEMENT_IDEAL_TYPE]: 'ideal',
  [STRIPE_PAYMENT_ELEMENT_KLARNA_TYPE]: 'klarna',
  [STRIPE_PAYMENT_ELEMENT_PAYNOW_TYPE]: 'paynow',
  [STRIPE_PAYMENT_ELEMENT_WECHATPAY_TYPE]: 'wechat_pay',
  [STRIPE_PAYMENT_ELEMENT_GRABPAY_TYPE]: 'grabpay',
}

export const PROMO_TYPE_PERCENTAGE = 'percentage'
export const PROMO_TYPE_FIXED = 'fixed_amount'

export const HIGH_VALUE_ORDER_AUD = 2999

export const MIN_KLARNA_PAYMENT = 35
export const MAX_KLARNA_PAYMENT = 2500

export const MAX_AFTER_PAY_BP_AUD_PAYMENT = 2000
export const MAX_AFTER_PAY_BP_USD_PAYMENT = 3000
export const MAX_AFTER_PAY_BP_NZD_PAYMENT = 3000

export const MIN_KLARNA_BP_USD_PAYMENT = 35
export const MIN_KLARNA_BP_NZD_PAYMENT = 35
export const MIN_KLARNA_BP_GBP_PAYMENT = 35

export const MAX_KLARNA_BP_USD_PAYMENT = 4000
export const MAX_KLARNA_BP_NZD_PAYMENT = 4000
export const MAX_KLARNA_BP_GBP_PAYMENT = 1000

export const MIN_HOOLAH_BP_SGD_PAYMENT = 30
export const MIN_HOOLAH_BP_MYR_PAYMENT = 100
export const MIN_HOOLAH_BP_HKD_PAYMENT = 100

export const MAX_HOOLAH_BP_SGD_PAYMENT = 2000
export const MAX_HOOLAH_BP_MYR_PAYMENT = 5000
export const MAX_HOOLAH_BP_HKD_PAYMENT = 10000

export const MIN_ATOME_BP_SGD_PAYMENT = 30
export const MIN_ATOME_BP_MYR_PAYMENT = 100
export const MIN_ATOME_BP_HKD_PAYMENT = 100

export const MAX_ATOME_BP_SGD_PAYMENT = 4000
export const MAX_ATOME_BP_MYR_PAYMENT = 6000
export const MAX_ATOME_BP_HKD_PAYMENT = 23000

export const MAX_STRIPE_CUSTOM_PAYTO_PAYMENT = 20000

export const INELEGIBLE_SERVICE_FEE_OFFER_TYPES: Array<App.OfferType> = ['connection_tour', 'cruise']
export const DEPOSIT_ENABLED_CURRENCIES = ['AUD', 'USD', 'NZD', 'GBP', 'SGD', 'CAD', 'CNY', 'EUR', 'HKD', 'IDR', 'ILS', 'JPY', 'KRW', 'MOP', 'MYR', 'PHP', 'QAR', 'RUB', 'SAR', 'TWD', 'THB', 'ZAR', 'AED', 'VND']
export const MIN_DEPOSITS_AUD_PAYMENT = 0
export const MIN_DEPOSITS_USD_PAYMENT = 0
export const MIN_DEPOSITS_NZD_PAYMENT = 0
export const MIN_DEPOSITS_GBP_PAYMENT = 0
export const MIN_DEPOSITS_SGD_PAYMENT = 0
export const MIN_DEPOSITS_CAD_PAYMENT = 0
export const MIN_DEPOSITS_CNY_PAYMENT = 0
export const MIN_DEPOSITS_EUR_PAYMENT = 0
export const MIN_DEPOSITS_HKD_PAYMENT = 0
export const MIN_DEPOSITS_IDR_PAYMENT = 0
export const MIN_DEPOSITS_ILS_PAYMENT = 0
export const MIN_DEPOSITS_JPY_PAYMENT = 0
export const MIN_DEPOSITS_KRW_PAYMENT = 0
export const MIN_DEPOSITS_MOP_PAYMENT = 0
export const MIN_DEPOSITS_MYR_PAYMENT = 0
export const MIN_DEPOSITS_PHP_PAYMENT = 0
export const MIN_DEPOSITS_QAR_PAYMENT = 0
export const MIN_DEPOSITS_RUB_PAYMENT = 0
export const MIN_DEPOSITS_SAR_PAYMENT = 0
export const MIN_DEPOSITS_TWD_PAYMENT = 0
export const MIN_DEPOSITS_THB_PAYMENT = 0
export const MIN_DEPOSITS_ZAR_PAYMENT = 0
export const MIN_DEPOSITS_AED_PAYMENT = 0
export const MIN_DEPOSITS_VND_PAYMENT = 0

export const REFUND_TO_CREDIT_REASON = 'Covid 19'
export const REFUND_DUE_TO_CHANGE_OF_MIND_REASON = 'Change of Mind Within Refund Guarantee Period'
export const REFUND_TO_CREDIT_COMMENT = 'Self-serve by customer'

export const REFUND_BACK_TO_ORIGIN_COMMENT = 'Self-serve by customer'

export const SHADOW_BAN_USER_ERROR_MESSAGE = 'Something went wrong with the payment'

export const REFUND_TYPE_BACK_TO_ORIGIN = 'back_to_origin'
export const REFUND_TYPE_CREDIT = 'credit'

export const CURRENCY_MIN_DEPOSIT_AMOUNT_MAP: Record<string, number> = {
  AUD: MIN_DEPOSITS_AUD_PAYMENT,
  USD: MIN_DEPOSITS_USD_PAYMENT,
  NZD: MIN_DEPOSITS_NZD_PAYMENT,
  GBP: MIN_DEPOSITS_GBP_PAYMENT,
  SGD: MIN_DEPOSITS_SGD_PAYMENT,
  CAD: MIN_DEPOSITS_CAD_PAYMENT,
  CNY: MIN_DEPOSITS_CNY_PAYMENT,
  EUR: MIN_DEPOSITS_EUR_PAYMENT,
  HKD: MIN_DEPOSITS_HKD_PAYMENT,
  IDR: MIN_DEPOSITS_IDR_PAYMENT,
  ILS: MIN_DEPOSITS_ILS_PAYMENT,
  JPY: MIN_DEPOSITS_JPY_PAYMENT,
  KRW: MIN_DEPOSITS_KRW_PAYMENT,
  MOP: MIN_DEPOSITS_MOP_PAYMENT,
  MYR: MIN_DEPOSITS_MYR_PAYMENT,
  PHP: MIN_DEPOSITS_PHP_PAYMENT,
  QAR: MIN_DEPOSITS_QAR_PAYMENT,
  RUB: MIN_DEPOSITS_RUB_PAYMENT,
  SAR: MIN_DEPOSITS_SAR_PAYMENT,
  TWD: MIN_DEPOSITS_TWD_PAYMENT,
  THB: MIN_DEPOSITS_THB_PAYMENT,
  ZAR: MIN_DEPOSITS_ZAR_PAYMENT,
  AED: MIN_DEPOSITS_AED_PAYMENT,
  VND: MIN_DEPOSITS_VND_PAYMENT,
}

export const DEPOSIT_STATUS = {
  DEPOSIT_TAKEN: 'deposit_taken',
  DEPOSIT_FAILED: 'deposit_failed',
  DEPOSIT_DETAILS_CREATED: 'deposit_details_created',
  DUE_BALANCE_MANUAL_DEBIT_TAKEN: 'due_balance_manual_debit_taken',
  DUE_BALANCE_AUTO_DEBIT_TAKEN: 'due_balance_auto_debit_taken',
  DUE_BALANCE_AUTO_DEBIT_FAILED: 'due_balance_auto_debit_failed',
  DUE_BALANCE_MANUAL_DEBIT_FAILED: 'due_balance_manual_debit_failed',
  FULL_BALANCE_REFUNDED: 'full_balance_refunded',
}

export const PAYMENT_METHODS_NOT_ALLOWED_REFUND: Array<string> = []

export interface PaypalSupplementaryData {
  ota_service_start_date?: string
  ota_service_end_date?: string
  ota_start_country?: string
}

export enum AGENT_HUB_PAYMENT_MODE {
  PAY_NET_AMOUNT = 'pay_net_amount',
  PAY_GROSS_AMOUNT = 'pay_gross_amount',
}

export enum PAYMENT_OPTIONS {
  FULL = 'full',
  DEPOSIT = 'deposit',
  RESERVE_FOR_FREE = 'reserve_for_free',
  PAYMENT_SCHEDULE = 'payment_schedule',
  DYNAMIC_PAYMENT_SCHEDULE = 'dynamic_payment_schedule',
}

export enum PAYTO_PAYMENT_OPTIONS {
  PAY_VIA_BANK = 'payto-bank',
  PAY_VIA_PAYID = 'payto-payid',
}

export enum INSTALMENT_PLANS {
  SINGLE = 'single',
  MONTHLY = 'monthly',
  FORTNIGHTLY = 'fortnightly',
  WEEKLY = 'weekly',
}

export enum INSTALMENT_PERIODS {
  WEEKLY = 7,
  FORTNIGHTLY = 14,
  MONTHLY = 30,
}

export const DEPOSIT_PENDING_BALANCE_STATUSES: Set<string> = new Set([
  DEPOSIT_STATUS.DEPOSIT_TAKEN,
  DEPOSIT_STATUS.DUE_BALANCE_AUTO_DEBIT_FAILED,
  DEPOSIT_STATUS.DUE_BALANCE_MANUAL_DEBIT_FAILED,
])

export const DEPOSIT_BALANCE_PAYMENT_STATUSES: Set<string> = new Set([
  DEPOSIT_STATUS.DEPOSIT_TAKEN,
  DEPOSIT_STATUS.DUE_BALANCE_AUTO_DEBIT_FAILED,
  DEPOSIT_STATUS.DUE_BALANCE_MANUAL_DEBIT_FAILED,
  DEPOSIT_STATUS.DUE_BALANCE_MANUAL_DEBIT_TAKEN,
])

export const DEPOSIT_BALANCE_MANUAL_PAYMENT_STATUSES: Set<string> = new Set([
  DEPOSIT_STATUS.DUE_BALANCE_MANUAL_DEBIT_FAILED,
  DEPOSIT_STATUS.DUE_BALANCE_MANUAL_DEBIT_TAKEN,
])

export const DEPOSIT_PAID_BALANCE_STATUSES: Set<string> = new Set([
  DEPOSIT_STATUS.DUE_BALANCE_AUTO_DEBIT_TAKEN,
  DEPOSIT_STATUS.DUE_BALANCE_MANUAL_DEBIT_TAKEN,
  DEPOSIT_STATUS.FULL_BALANCE_REFUNDED,
])

export enum INSTALMENT_STATUS {
  INITIAL_PAYMENT_TAKEN = 'initial_payment_taken', // Initial payment paid by user
  PAYMENT_FAILED = 'payment_failed', // FAILURE: Initial payment failed
  INSTALMENT_DUE_BALANCE_MANUAL_DEBIT_FAILED = 'payment_due_balance_manual_debit_failed', // FAILURE: Manual payment of due balance amount failed
  PAYMENT_REFUNDED = 'payment_refunded',
  PAYMENT_FULL_BALANCE_REFUNDED = 'payment_full_balance_refunded',
  PAYMENT_MANUAL_DEBIT_TAKEN = 'payment_manual_debit_taken',
  PAYMENT_MANUAL_DEBIT_FAILED = 'payment_manual_debit_failed',
  PAYMENT_TAKEN_COMPLETE = 'payment_taken_complete',
  PAYMENT_MANUAL_DEBIT_TAKEN_COMPLETE = 'payment_manual_debit_taken_complete',
  PAYMENT_AUTO_DEBIT_TAKEN = 'payment_auto_debit_taken',
  PAYMENT_AUTO_DEBIT_FAILED = 'payment_auto_debit_failed',
  PAYMENT_UPCOMING = 'payment_upcoming', // independent status for showing unpaid instalments
  CREDIT_APPLIED = 'credit_applied', // independent status for showing initial credit applied
}

export const INSTALMENT_PENDING_BALANCE_STATUSES: Set<string> = new Set([
  INSTALMENT_STATUS.INITIAL_PAYMENT_TAKEN,
  INSTALMENT_STATUS.PAYMENT_AUTO_DEBIT_TAKEN,
  INSTALMENT_STATUS.PAYMENT_AUTO_DEBIT_FAILED,
  INSTALMENT_STATUS.INSTALMENT_DUE_BALANCE_MANUAL_DEBIT_FAILED,
  INSTALMENT_STATUS.PAYMENT_MANUAL_DEBIT_TAKEN,
  INSTALMENT_STATUS.PAYMENT_MANUAL_DEBIT_FAILED,
])

export const INSTALMENT_PAYMENT_STATUSES: Set<string> = new Set([
  INSTALMENT_STATUS.PAYMENT_TAKEN_COMPLETE,
  INSTALMENT_STATUS.PAYMENT_MANUAL_DEBIT_TAKEN,
  INSTALMENT_STATUS.PAYMENT_MANUAL_DEBIT_FAILED,
  INSTALMENT_STATUS.PAYMENT_MANUAL_DEBIT_TAKEN_COMPLETE,
  INSTALMENT_STATUS.INSTALMENT_DUE_BALANCE_MANUAL_DEBIT_FAILED,
  INSTALMENT_STATUS.PAYMENT_AUTO_DEBIT_FAILED,
])

export const INSTALMENT_MANUAL_PAYMENT_SUCCESS_STATUSES: Set<string> = new Set([
  INSTALMENT_STATUS.PAYMENT_TAKEN_COMPLETE,
  INSTALMENT_STATUS.PAYMENT_MANUAL_DEBIT_TAKEN,
])

export const INSTALMENT_PAYMENT_SUCCESS_STATUSES: Set<string> = new Set([
  INSTALMENT_STATUS.INITIAL_PAYMENT_TAKEN,
  INSTALMENT_STATUS.PAYMENT_TAKEN_COMPLETE,
  INSTALMENT_STATUS.PAYMENT_AUTO_DEBIT_TAKEN,
  INSTALMENT_STATUS.PAYMENT_MANUAL_DEBIT_TAKEN_COMPLETE,
  INSTALMENT_STATUS.PAYMENT_MANUAL_DEBIT_TAKEN,
])

export const INSTALMENT_PAYMENT_FAILURE_STATUSES: Set<string> = new Set([
  INSTALMENT_STATUS.PAYMENT_FAILED,
  INSTALMENT_STATUS.PAYMENT_MANUAL_DEBIT_FAILED,
  INSTALMENT_STATUS.PAYMENT_AUTO_DEBIT_FAILED,
  INSTALMENT_STATUS.INSTALMENT_DUE_BALANCE_MANUAL_DEBIT_FAILED,
])

export const INSTALMENT_PAYMENT_REFUND_STATUSES: Set<string> = new Set([
  INSTALMENT_STATUS.PAYMENT_REFUNDED,
  INSTALMENT_STATUS.PAYMENT_FULL_BALANCE_REFUNDED,
])

export enum INSTALMENT_PAYMENT_TYPE {
  INSTALMENT_PAYMENT = 'instalment_payment',
  INSTALMENT_BALANCE = 'instalment_balance',
}

export const ZERO_DECIMAL_CURRENCIES = new Set([
  'BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA',
  'PYG', 'RWF', 'VND', 'VUV', 'XAF', 'XOF', 'XPF',
])

export const COMP_PROMO_CODE = 'LEPRIZE'
export const FRIENDS_AND_FAMILY_PROMOS = ['FAMILYANDFRIENDS20', 'FAMILYANDFRIENDS10']

export enum RESERVE_FOR_ZERO_STATUS {
  BOOKING_DETAILS_CREATED = 'booking_details_created',
  PAYMENT_PENDING = 'payment_pending',
  PAYMENT_TAKEN = 'payment_taken',
  BOOKING_CANCELLED = 'booking_cancelled',
  SUBSCRIPTION_CREATION_ERRORED = 'subscription_creation_errored',
  SETUP_INTENT_ERRORED = 'setup_intent_errored',
  PAYMENT_FAILED = 'payment_failed',
  PAYMENT_AUTO_DEBIT_TAKEN = 'payment_auto_debit_taken',
  PAYMENT_AUTO_DEBIT_FAILED = 'payment_auto_debit_failed',
  PAYMENT_MANUAL_DEBIT_TAKEN = 'payment_manual_debit_taken',
  PAYMENT_MANUAL_DEBIT_FAILED = 'payment_manual_debit_failed',
}

export enum SECURE_PAYMENT_OPTIONS {
  LINK_STANDALONE = 'link_standalone',
  LINK_VIA_SMS = 'link_via_sms',
}

export const RESERVE_FOR_ZERO_PENDING_BALANCE_STATUSES: Set<string> = new Set([
  RESERVE_FOR_ZERO_STATUS.PAYMENT_PENDING,
  RESERVE_FOR_ZERO_STATUS.PAYMENT_MANUAL_DEBIT_FAILED,
  RESERVE_FOR_ZERO_STATUS.PAYMENT_MANUAL_DEBIT_TAKEN,
])

export const RESERVE_FOR_ZERO_MANUAL_PAYMENT_STATUSES: Set<string> = new Set([
  RESERVE_FOR_ZERO_STATUS.PAYMENT_MANUAL_DEBIT_FAILED,
  RESERVE_FOR_ZERO_STATUS.PAYMENT_MANUAL_DEBIT_TAKEN,
])

export const BASE_MERCHANT_FEE = 0.95
export const DEBIT_CARD_MERCHANT_FEE = 0.3

export const SHORT_LEAD_TIME_WITH_CREDIT_MODAL_LEAD_TIME_DAYS = 7
export const SHORT_LEAD_TIME_WITH_GOOGLE_PAY_LEAD_TIME_DAYS = 10
export const SHORT_LEAD_TIME_WITH_PAYPAL_LEAD_TIME_DAYS = 21
export const SHORT_LEAD_TIME_WITH_CREDIT_MODAL_PERCENTAGE_THRESHOLD = 0.1

export const PAYMENT_RESTRICTED_CURRENCIES_FOR_SPOOFED = ['INR']

export const STRIPE_TERMINAL_STORE_UTMS = ['chadstone_store', 'bondi_store']

const AUSTRALIAN_MOBILE_PREFIX = '61'
export const SMS_SUPPORTED_PHONE_PREFIXES = [AUSTRALIAN_MOBILE_PREFIX]

export const PAYMENT_SCHEDULE_STATUS = {
  PAID: 'paid',
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
  MANUAL_DEBIT: 'manual_debit',
}

export const PAYMENT_SCHEDULE_CHARGE_STATUS = {
  PAID: 'paid',
  PENDING: 'pending',
  FAILED: 'failed',
  REFUNDED: 'refunded',
}

export const ACTIVE_PAYMENT_SCHEDULE_STATUSES = [PAYMENT_SCHEDULE_STATUS.PAID, PAYMENT_SCHEDULE_STATUS.ACTIVE]

export const INACTIVE_PAYMENT_SCHEDULE_STATUSES = [PAYMENT_SCHEDULE_STATUS.CANCELLED, PAYMENT_SCHEDULE_STATUS.REFUNDED]

export const PAYMENT_SCHEDULE_BALANCE_STATUSES: Set<string> = new Set([
  PAYMENT_SCHEDULE_STATUS.ACTIVE,
  PAYMENT_SCHEDULE_STATUS.PAID,
  PAYMENT_SCHEDULE_STATUS.CANCELLED,
  PAYMENT_SCHEDULE_STATUS.REFUNDED,
])

export const HIGH_RISK_TRANSACTION_CREDIT_PERCENTAGE_THRESHOLD = 0.1
export const HIGH_RISK_LEAD_TIME_FOR_MAJORITY_CREDIT_IN_DAYS = 10

export const loyaltyPaymentTypes = new Set<App.OrderPaymentType>([
  'le_points',
  'le_points_discounted_insurance',
  'le_points_airport_transfer',
  'le_points_hotel_upgrade',
  'le_points_lounge_pass',
  'le_points_travelshoot_voucher',
  'le_points_tour_optional_extra_voucher',
])

export const loyaltyBenefitPaymentTypes = new Set<App.OrderPaymentType>([
  'le_points_discounted_insurance',
  'le_points_airport_transfer',
  'le_points_hotel_upgrade',
  'le_points_lounge_pass',
  'le_points_travelshoot_voucher',
  'le_points_tour_optional_extra_voucher',
])

export const SHORT_LEAD_TIME_WITH_FLYING_BLUE_LEAD_TIME_DAYS = 7

export const DEPOSIT_BALANCE_DUE_DATE_NUMBER_OF_DAYS_THRESHOLD = 7

export enum PAYMENT_CHECKOUT_TYPES {
  Default = 'default', // initial purchase
  ChangeDates = 'change_dates',
  ChangePackage = 'change_package',
  PartnerChangePackage = 'partner_change_package',
  AddExtraGuests = 'add_extra_guests',
  CustomOffer = 'custom_offer',
  Instalment = 'instalment',
  InstalmentBalance = 'instalment_balance',
  DepositBalance = 'deposit_balance',
  ReserveBalance = 'reserve_balance',
  PaymentScheduleBalance = 'payment_schedule_balance',
  Unknown = 'unknown',
}

export enum PAYMENT_SCHEDULE_TYPE {
  STATIC = 'static',
  DYNAMIC = 'dynamic',
}

// Hardcoded static payment schedule template ID used in the static vs dynamic A/B test.
// When a user is in the "static" variant, this template ID is sent to svc-payment
// instead of the dynamic template from the offer.
// TODO: Replace with the actual static template ID from svc-payment
export const STATIC_PAYMENT_SCHEDULE_TEMPLATE_ID = '001_hotel_50_percentage_2_payments'
